import { render, staticRenderFns } from "./FreeVehicleView.vue?vue&type=template&id=3ff4f4b6&"
import script from "./FreeVehicleView.vue?vue&type=script&lang=js&"
export * from "./FreeVehicleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports